import React from 'react'
import PropTypes from 'prop-types'
import st from './AccentSaveAnswer.module.scss'
import { ReactComponent as SaveIcon } from 'components/UI/icons/save-line.svg'
import { ReactComponent as AlarmIcon } from 'components/UI/icons/alarm-warning-line.svg'

const AccentSaveAnswer = ({ isActive, onClick, translate }) => {
  return (
    <div
      className={`${st.accentSaveAnswer} ${isActive ? '' : st.accentSaveAnswer__noHover}`}
    >
      {isActive ? (
        <span>
          <SaveIcon />
          {translate.dont_forget}!
        </span>
      ) : (
        <span className={st.danger}>
          <AlarmIcon /> {translate.didnt_answer_task}.
        </span>
      )}
      <button className={isActive ? undefined : st.hide} onClick={onClick}>
        {translate.save_answer}
      </button>
    </div>
  )
}

AccentSaveAnswer.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default AccentSaveAnswer
